import { FC } from 'react';
import { DateTime } from 'luxon';
import styled from '@emotion/styled';

import { Divider } from '@material-ui/core';
import { Organization } from '@kaizenplatform/intelligence-entity';

import { PaperContent, PaperTitle, PaperTitleText, StyledPaper } from '../../primitive/Paper';
import { useLinkPrefetchReport } from '../../../../hooks/useLinkPrefetchReport';
import SpeculationRule from '../../../../entity/SpeculationRule';
import ReportChart from './ReportChart';
import ReportTable from './ReportTable';
import StyledLoading from './StyledLoading';
import ReportEmpty from './ReportEmpty';

type Props = {
  organization: Organization;
  speculationRule: SpeculationRule;
  toDate: DateTime;
  fromDate: DateTime;
};

const ReportContent: FC<Props> = ({ organization, fromDate, toDate }) => {
  const { error, loading, reportData } = useLinkPrefetchReport(organization.id, fromDate, toDate);

  if (error) {
    throw new Error(`レポートの取得に失敗しました: ${error.message}`);
  }
  if (loading || !reportData) {
    return <StyledLoading />;
  }
  if (!reportData || Object.keys(reportData.patterns).length === 0) {
    return <ReportEmpty />;
  }

  return (
    <Container>
      <StyledPaper style={{ marginTop: 0 }}>
        <PaperContent>
          <PaperTitle>
            <PaperTitleText>
              速度改善レポート
              <PaperTitleNote>(毎日午前3時頃に更新)</PaperTitleNote>
            </PaperTitleText>
          </PaperTitle>
          <Divider style={{ marginTop: 12, marginBottom: 16 }} />
          <ReportChart reportData={reportData} />
          <Divider style={{ marginTop: 24, marginBottom: 24 }} />
          <ReportTable reportData={reportData} />
        </PaperContent>
      </StyledPaper>
    </Container>
  );
};

const Container = styled('div')({
  width: '100%',
});

export const PaperTitleNote = styled('span')(`
  font-size: 15px;
  padding-left: 8px;
`);

export default ReportContent;
